import { render, staticRenderFns } from "./PFormError.vue?vue&type=template&id=4b9e11d5&"
import script from "./PFormError.vue?vue&type=script&lang=js&"
export * from "./PFormError.vue?vue&type=script&lang=js&"
import style0 from "./PFormError.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports